// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ApiPagingRequestSchema from './api-paging-request-schema';

const schema = {
  $id: '/get-widget-events-request-schema',
  type: 'object',
  required: ['toccoFilter'],
  properties: {
    searchCriteria: {
      type: 'string',
      nullable: true,
    },
    paging: {
      ...ApiPagingRequestSchema,
    },
    toccoFilter: {
      type: 'string',
      minLength: 1,
    },
    searchTag: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
